<template>
  <loading
    v-model:active="isLoading"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="fullPage"
  />
  <router-view />
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters({
      LOADING_STATUS: "Main/_LoadingSTATUS",
    }),
  },
  watch: {
    LOADING_STATUS: async function () {
      if (this.LOADING_STATUS === false) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
      }
    },
  },
  methods: {
    doAjax() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 5000);
    },
    onCancel() {
      console.log("User cancelled the loader.");
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;1,200&family=Sarabun:wght@100;200;300&display=swap");
#app {
  font-family: Sarabun, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
